import { isObject } from "lodash";
import { NullValue } from "./../../../ricos-schema/legacy/wix/rich_content/v1";
const isBoolValue = (val) => typeof val.boolValue === "boolean";
const isStringValue = (val) => typeof val.stringValue === "string";
const isNumberValue = (val) => typeof val.numberValue === "number";
const isArrayValue = (val) => isObject(val.listValue) && Array.isArray(val.listValue?.values);
const isStructValue = (val) => isObject(val.structValue) && isObject(val.structValue?.fields);
const isNullValue = (val) => val.nullValue === NullValue.NULL_VALUE;
export {
  isArrayValue,
  isBoolValue,
  isNullValue,
  isNumberValue,
  isStringValue,
  isStructValue
};
//# sourceMappingURL=struct-refined-types.js.map
